import React from 'react'
import './styles.scss'

interface IPropType {
  leftText: string;
  rightText: string;
}

export default function ResultBox({ leftText, rightText }: IPropType) {
  return (
    <div className='total-container'>
      <span style={{
        fontSize: 16,
        fontWeight: 'bolder',
      }}>{leftText}</span>
      <span style={{
        fontSize: 22,
        fontWeight: 'bolder',
        textTransform: 'uppercase',
      }}>{rightText}</span>
    </div>
  )
}
